import React, { useRef, useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch } from 'react-redux';
import { fetchdata, fetchviewdata, ApproveData, RejectData, fetchviewDoc } from '../reduxactions/adminrsactions/AdViewFundActions';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { useSelector } from 'react-redux';
import './AdminViewFund.css';

import { RootState } from '../reducers';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Calendar } from 'primereact/calendar';

import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Message } from 'primereact/message';
import { GFNButton } from '../ui';

export const AdminViewFund = () => {

  const uid = window.sessionStorage.getItem('uid');
  const [globalFilter, setGlobalFilter] = useState('');
  const [edate, setDate] = useState<Date | null>(new Date());
  const location = useLocation();

  const [queryParams, setQueryParams] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setQueryParams(params.get("fundman_id") as any);
  }, [location]);
  const { fundman_id } = useParams();
  console.log('Row ID:', fundman_id);
  const dispatch = useDispatch()
  const data = useSelector((state: RootState) => state.adfunddocument.data);
  const viewdata = useSelector((state: RootState) => state.adfunddocument.viewdata);
  const rejectdata = useSelector((state: RootState) => state.adfunddocument.rejectdata);
  const approvedata = useSelector((state: RootState) => state.adfunddocument.approvedata);
  const docdata = useSelector((state: RootState) => state.adfunddocument.docdata);
  const toast = useRef(approvedata);
  const toast1 = useRef(rejectdata);

  const Closebutton = async () => {

    setApproveConfirmation(false);


  }
  //To get data
  const fetchDataAsync = async () => {
    try {
      await dispatch(fetchdata(fundman_id) as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetchDataViewAsync = async () => {
    try {
      await dispatch(fetchviewdata(fundman_id) as any);
    } catch (error) {
      console.error('Error fetching data', error)
    }
  }
  // To get data
  useEffectOnce(() => {
    fetchDataAsync();
    fetchDataViewAsync();

  }, [dispatch]);

  const [approveConfirmation, setApproveConfirmation] = useState(false);
  const Approve = (response: any) => {
    appData.current = { id: response.fundman_id }


    setApproveConfirmation(true);
  };
  const appData = useRef({ id: '' })

  const confirmApprove = async () => {
    try {
      await dispatch(ApproveData(fundman_id, edate) as any);
      toast.current.show({ severity: 'success', summary: 'Approved Successfully', life: 3000 })
      setApproveConfirmation(false);
      setTimeout(() => {
        window.location.reload();
      }, 3000);



    } catch (error) {
      console.error('Error approving :', error);
    }

    fetchDataAsync();

  };
  const [rejectConfirmation, setRejectConfirmation] = useState(false);
  const [rejData, setRejecteData] = useState({
    id: '',

  });
  const Reject = (response: any) => {
    setRejecteData({
      id: response.fundman_id

    });
    setRejectConfirmation(true);
  };
  const confirmReject = async () => {
    const { id } = rejData;
    try {
      await dispatch(RejectData(fundman_id) as any);
      toast.current.show({ severity: 'info', summary: 'Info', detail: 'Rejected Succesfully', life: 3000 })
      setRejectConfirmation(false);
    } catch (error) {
      console.error('Error while rejecting', error);
    }

    fetchDataViewAsync();

  };
  const [acceptfield, setfield] = useState(false);
  const [docData, setDocData] = useState({
    docid: '',
  });
  const viewDoc = (response: any) => {
    setDocData({
      docid: response.DocID

    });
    setfield(true);
    fetchdocdata(response.DocID);
  };
  const cancelfield = () => {
    setfield(false);
  }
  //To assign data 
  const fetchdocdata = async (docid: any) => {
    // const { docid } = docData;
    try {
      await dispatch(fetchviewDoc(docid) as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  //for help
  const [openHelp, setHelp] = useState(false);
  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/adminviewfundmanager.php`;
  const helpImg = `${url1}/help/help3.png`;
  const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      'newwindow',
      'width=1000,height=1000,noopener,noreferrer'
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };
  return (
    <div className="admin-layout-container">
      <div className="row">
        <div className="main-content">
          {/* <div className="col-16" style={{ textAlign: "right" }}>
            <a
              title="help"
              onClick={(e) => openWindow(e, IUrl)}
              style={{

                color: "blue",
                fontSize: 15, cursor: "pointer"
              }}
            >Help for this Page &nbsp;
              <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

            </a>
          </div> */}
          <section className="app-page-header">
            <div>
              <h1 className="app-page-title">View Fund Managers</h1>
            </div>
            <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
              Help for this Page
              <i className="pi pi-question-circle"></i>
            </a>
          </section>
          <div className="content-wrapper mt-4">
            {viewdata.map((response: any) =>
              <section className="content">
                <Card title="">
                  <Panel header="Fund Manager Information">
                    <div className="grid">

                      <div className="col-12 md:col-12 lg:col-6">
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Fund Manager Name :</strong>
                          <p className="text-muted">{response.name}</p>
                        </div>


                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Email :</strong>
                          <p className="text-muted">{response.email}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>License No :</strong>
                          <p className="text-muted">{response.licenceno}</p>
                        </div>
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>License Expired Date :</strong>
                          <p className="text-muted">{response.license_expiredate}</p>
                        </div>
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Application Status :</strong>
                          <p className="text-muted">{response.status}</p>
                        </div>
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Profile Expired Date :</strong>
                          <p className="text-muted">{response.user_expiredate}</p>
                        </div>

                      </div>
                      <div className="col-12 md:col-12 lg:col-6">
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Address :</strong>
                          <p className="text-muted">{response.address}</p>
                        </div>


                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Contact No :</strong>
                          <p className="text-muted">{response.phoneno}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Country :</strong>
                          <p className="text-muted">{response.CountryName}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Paypal Account :</strong>
                          <p className="text-muted">{response.paypal_account}</p>
                        </div>
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Website :</strong>
                          <p className="text-muted">{response.website_url}</p>
                        </div>
                      </div>
                    </div>
                  </Panel>
                </Card>
              </section>
            )}
            <section className="content">
              <Card title="">
                <Panel header="Attachments">
                  <div className="grid">
                    <div className="col-12">
                      <div className="card card-primary">
                        <div className="card flex flex-wrap justify-content">
                          <span className="p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                          </span>
                        </div>
                        <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                          <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                          <Column field="doc_name" sortable header="Attachment Name"></Column>
                          <Column field="CreteDate" sortable header="Expiry Date"></Column>
                          <Column header="View" body={(rowData, { rowIndex }) => (
                            <>
                              {/* <Button icon="pi pi-eye" data-testid={`view-btn-${rowIndex}`} rounded outlined tooltip="View" onClick={() => viewDoc(rowData)} style={{ backgroundColor: 'white', color: 'blue' }}></Button> */}
                              <GFNButton icon="pi pi-eye" buttonType="primary" size="sm" tooltip="View" testId={`view-btn-${rowData.DocID}`} onClick={() => viewDoc(rowData)} />
                            </>
                          )} />
                        </DataTable>
                      </div>
                    </div>
                  </div>
                </Panel>
              </Card>
              <br></br>
              <div className='grid'>
                <div className='col-9'></div>
                <div className='col-3'>
                  {viewdata.map((response: any) => (
                    <>
                      {(response.status === 'Approved' || response.status === 'Applied') && (
                        // <Button className='mr-1' severity="danger" data-testid="reject-btn" label="Reject" rounded onClick={() => Reject(response)} />
                        <GFNButton
                          className="mr-1"
                          buttonType="danger"
                          testId="reject-btn"
                          label="Reject"
                          onClick={() => Reject(response)}
                        />
                      )}
                      {(response.status === 'Applied' && (
                        // <Button className='mr-1' severity="success" data-testid="approve-btn" label="Approve" rounded onClick={() => Approve(response)} />
                        <GFNButton
                          className="mr-1"
                          buttonType="success"
                          testId="approve-btn"
                          label="Approve"
                          onClick={() => Approve(response)}
                        />
                      )
                      )}
                    </>

                  ))}
                </div>
              </div>
            </section>
          </div>
          {/*Approve DIALOG */}
          <Dialog header="Confirm Approve" data-testid="approve-dialog" style={{ width: '30vw' }} visible={approveConfirmation} onHide={() => setApproveConfirmation(false)}>
            <div className="grid pt-3">
              <div className="col-8">
                <label htmlFor="dd-mm-yyyy" className="col-sm-2 control-label">Expiry Date:</label>
              </div>
              <div className="col-7" >
                <Calendar className="calendar-container"
                  id="expdate"
                  data-testid="exdate-date"
                  style={{ width: '200px' }} // Adjust width as needed
                  name="date"
                  placeholder='dd-mm-yyyy'
                  onChange={(e) => e.value && setDate(e.value)}
                  showIcon
                />
              </div>
            </div>

            {/* <Button label="Yes" icon="pi pi-check" data-testid="approve-yes-btn" className='mr-3 p-button-raised' onClick={confirmApprove} />
            <Button label="No" icon="pi pi-times" data-testid="approve-no-btn" onClick={Closebutton} className="mr-3 p-button-secondary" /> */}
            <GFNButton label="Yes" icon="pi pi-check" testId="approve-yes-btn" className='mr-3 mt-4' buttonType="success" onClick={confirmApprove} />
            <GFNButton label="No" icon="pi pi-times" testId="approve-no-btn" onClick={Closebutton} className="mr-3 mt-4" buttonType="secondary" />
          </Dialog>
          {/*Reject DIALOG */}
          <Dialog header="Confirm Reject" data-testid="reject-dialog" style={{ width: '30vw' }} visible={rejectConfirmation} onHide={() => setRejectConfirmation(false)}>
            <div>Are you sure you want to Reject this item?</div>
            {/* <Button label="Yes" icon="pi pi-check" data-testid="reject-yes-btn" className='mr-3 p-button-raised' onClick={confirmReject} />
            <Button label="No" icon="pi pi-times" data-testid="reject-no-btn" onClick={Closebutton} className="mr-3 p-button-secondary" /> */}
            <GFNButton label="Yes" icon="pi pi-check" testId="reject-yes-btn" className='mr-3 mt-4' buttonType="danger" onClick={confirmReject} />
            <GFNButton label="No" icon="pi pi-times" testId="reject-no-btn" onClick={Closebutton} className="mr-3 mt-4" buttonType="secondary" />
          </Dialog>
          <Dialog header="View" style={{ width: '50vw' }} data-testid="view-dailog" visible={acceptfield} onHide={cancelfield}>
            <div className="modal-header">

            </div>
            <form>
              <div className="modal-body">
                {docdata.map((rowData: any, index: number) =>
                  <div key={index}>
                    {rowData.filetype === 'image' && <img src={rowData.displayfile} alt="Doc" width="100%" height="auto" />}

                  </div>
                )}
              </div>
              {/* <Button label="Close" data-testid="view-close-btn" onClick={cancelfield} className="mr-3 p-button-secondary" /> */}
              <GFNButton label="Close" testId="view-close-btn" onClick={cancelfield} className="mr-3" buttonType="secondary" />
            </form>
          </Dialog>
          <Toast ref={toast} >
            <Message severity="success" content={approvedata} />
          </Toast>
        </div>
      </div>
    </div>
  )
}
export default AdminViewFund
